import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { AdminModule } from './admin/admin.module';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { FileUploadModule } from 'primeng/fileupload';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './auth/auth.guard';
import { DashboardCardComponent } from './home/dashboard-card/dashboard-card.component';
import { OutcomeModalComponent } from './home/outcome-modal/outcome-modal.component';
import { DialogService } from 'primeng/dynamicdialog';
import { QuarterlyOutcomeListComponent } from './home/outcome-modal/quarterly-outcome-list/quarterly-outcome-list.component';
import { OutcomeComponent } from './outcome/outcome.component';
import { MyTasksComponent } from './my-tasks/my-tasks.component';
import { DependenciesComponent } from './dependencies/dependencies.component';
import { RaisedToMeComponent } from './dependencies/raised-to-me/raised-to-me.component';
import { RaisedByMeComponent } from './dependencies/raised-by-me/raised-by-me.component';
import { KanbanDashboardComponent } from './kanban-dashboard/kanban-dashboard.component';
import { KanbanColumnComponent } from './kanban-dashboard/kanban-column/kanban-column.component';
import { KanbanCardComponent } from './kanban-dashboard/kanban-column/kanban-card/kanban-card.component';
import { ProgressDashboardComponent } from './progress-dashboard/progress-dashboard.component';
import { AnnualOutcomeListComponent } from './progress-dashboard/annual-outcome-list/annual-outcome-list.component';
import { DashboardComponent } from './work-package/dashboard/dashboard.component';
import { WpListComponent } from './work-package/wp-list/wp-list.component';
import { WpComponent } from './work-package/wp-list/wp/wp.component';
import { WpFormComponent } from './work-package/wp-form/wp-form.component';
import { WpButtonComponent } from './work-package/wp-button/wp-button.component';
import { MessageService } from 'primeng/api';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { WpDashboardCountPipe } from './work-package/pipes/wp-dashboard-count.pipe';
import { FilterByPlacePipe } from './work-package/pipes/filter-by-place.pipe';
import { IsOwnerPipe } from './work-package/pipes/is-owner.pipe';
import { IsMemberPipe } from './work-package/pipes/is-member.pipe';
import { DocTemplateComponent } from './work-package/doc-template/doc-template.component';
import { NoDataFoundComponent } from "./shared/no-data-found/no-data-found.component";
import { TruncatePipe } from './work-package/pipes/truncate.pipe';
import { IsPlanningPhasePipe } from './work-package/pipes/is-planning-phase.pipe';
import { WpDownloadFilesModalComponent } from './work-package/wp-list/wp-download-files-modal/wp-download-files-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    DashboardCardComponent,
    AuthComponent,
    OutcomeModalComponent,
    QuarterlyOutcomeListComponent,
    OutcomeComponent,
    MyTasksComponent,
    DependenciesComponent,
    RaisedToMeComponent,
    RaisedByMeComponent,
    KanbanDashboardComponent,
    KanbanColumnComponent,
    KanbanCardComponent,
    ProgressDashboardComponent,
    AnnualOutcomeListComponent,
    DashboardComponent,
    WpListComponent,
    WpComponent,
    WpButtonComponent,
    WpFormComponent,
    DocTemplateComponent,
    WpDownloadFilesModalComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    AdminModule,
    NgbCarouselModule,
    InfiniteScrollModule,
    WpDashboardCountPipe,
    ReactiveFormsModule,
    FilterByPlacePipe,
    IsOwnerPipe,
    IsMemberPipe,
    VirtualScrollerModule,
    FileUploadModule,
    NoDataFoundComponent,
],
  providers: [AuthGuard, DialogService, MessageService,IsOwnerPipe,IsPlanningPhasePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
